import { ComponentType } from "react";

/**
 * Interface submodulu customizací zajišťující, že
 */
export interface ICustomizationSubmodule {
    /**
     * Inicializační metoda, která nastaví registrátory.
     *
     * @internal
     */
    init(...args: any[]): void;
}

/**
 * Interface rendereru zajišťující jeho základní funkčnost.
 * Jednotlivé implementace si jej můžou rozšířit, přidat argumenty, metody, ...
 */
export interface IRenderer<ComponentProps = any> {
    /** Klíč rendereru. Musí být unikátní v daném registrátoru. */
    readonly key: string;
    /** React komponenta, která umí zobrazit daný prvek uživatelského rozhraní. */
    readonly component: ComponentType<ComponentProps>;
}

export class IRenderer {
    private static _properties: (keyof IRenderer)[] = ["key", "component"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return (
            instance != null &&
            this._properties.every((value) => Reflect.has(instance, value))
        );
    }
}

/**
 * Interface pro registrátor.
 * Jednotlivé implementace si mohou přidat atributy jednotlivým metodám, ...
 */
export interface IRendererRegistrator<RendererType extends IRenderer = any> {
    /** Zaregistruje renderer. */
    register(renderer: RendererType, ...args: any[]): void;
    /** Zaregistruje továrnu. */
    registerFactory(rendererFactory: () => RendererType, ...args: any[]): void;
    /** Získá renderer pro daný klíč. */
    getRendererByKey(key?: string): RendererType;
    /** Vrátí všechny renderery. */
    getAll(): ReadonlyArray<RendererType>;
}
